import ErrorNotification from "../components/notification/ErrorNotification";
import { NOTIFICATION_TITLE } from "../constants/MESSAGE";

// Helper function to handle API errors with automatic deduplication
export const handleApiError = (error: any, fallbackMessage?: string) => {
  const message = error?.message ?? fallbackMessage ?? NOTIFICATION_TITLE.ERROR;
  const statusCode = error?._statusCode || error?.statusCode || error?.status;
  if (statusCode === 401) return;
  const endpoint = error?._requestUrl || error?.url;

  ErrorNotification(message, undefined, {
    statusCode,
    endpoint,
  });
};

// Force show error notification (bypass deduplication)
export const forceErrorNotification = (error: any, fallbackMessage?: string) => {
  const message = error?.message ?? fallbackMessage ?? NOTIFICATION_TITLE.ERROR;

  ErrorNotification(message, undefined, {
    force: true,
  });
};

export default {
  handleApiError,
  forceErrorNotification,
};
